import React, { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame } from 'react-three-fiber';
import * as THREE from 'three';

const RotatingBall = ({ imageURL }) => {
  const meshRef = useRef();
  const [isDragging, setIsDragging] = useState(false);
  const [prevMouseCoords, setPrevMouseCoords] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseDown = () => {
      setIsDragging(true);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;
      const { innerWidth, innerHeight } = window;
      const mouseX = (clientX / innerWidth) * 2 - 1;
      const mouseY = -(clientY / innerHeight) * 2 + 1;
      const deltaMouseX = mouseX - prevMouseCoords.x;
      const deltaMouseY = mouseY - prevMouseCoords.y;
      if (isDragging) {
        meshRef.current.rotation.y += deltaMouseX * 0.5;
        meshRef.current.rotation.x += deltaMouseY * 0.5;
      }
      setPrevMouseCoords({ x: mouseX, y: mouseY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDragging, prevMouseCoords]);

  useFrame(() => {
    meshRef.current.rotation.y += 0.01;
  });

  const textureLoader = new THREE.TextureLoader();
  const texture = textureLoader.load(imageURL);
  texture.needsUpdate = true;

  const [radius, setRadius] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 601) {
        setRadius(1);
      } else {
        setRadius(2);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <mesh ref={meshRef}>
      <sphereGeometry args={[radius, 10, 10]} />
      <meshBasicMaterial polygonOffsetFactor={-5} map={texture} attach="material" />
    </mesh>
  );
};

const Ball = ({ imageURL }) => {
  return (
    <Canvas className="canvas-ball">
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <RotatingBall imageURL={imageURL} />
    </Canvas>
  );
};

export default Ball;
